import { Injectable } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subject } from 'rxjs';
import { IRequestSubjectEvent, RequestService } from '@df/api/request/request.service';

@Injectable({ providedIn: 'root' })
export class RequestStatusService {
    readonly subject = new Subject<Set<IRequestSubjectEvent>>();

    private requests = new Set<IRequestSubjectEvent>();

    constructor(
        private requestService: RequestService,
        private timeoutService: TimeoutService
    ) {
        this.requestService.requestSubject.subscribe((event: IRequestSubjectEvent) => {
            if (event.options.api === 'node') {
                return;
            }
            if (event.status === 'start') {
                this.requests.add(event);
                this.timeoutService.setTimeout(() => {
                    this.remove(event);
                }, 30000);
                this.subject.next(this.requests);
            } else {
                this.remove(event);
            }
        });
    }

    getRequests(): IRequestSubjectEvent[] {
        return Array.from(this.requests);
    }

    private remove(event: IRequestSubjectEvent) {
        if (this.requests.has(event)) {
            this.requests.delete(event);
            this.subject.next(this.requests);
        }
    }
}
